import type { ReactNode } from 'react';

export type Tone = 'tomato' | 'turmeric' | 'herb' | 'plum' | 'sea' | 'dim';

const TONE_VAR: Record<Tone, string> = {
  tomato: 'var(--tomato)',
  turmeric: 'var(--turmeric)',
  herb: 'var(--herb)',
  plum: 'var(--plum)',
  sea: 'var(--sea)',
  dim: 'var(--chalk-dim)',
};

export function Pill({
  children,
  tone = 'dim',
}: {
  children: ReactNode;
  tone?: Tone;
}): React.JSX.Element {
  return (
    <span className="pill" style={{ '--pill-tone': TONE_VAR[tone] } as React.CSSProperties}>
      {children}
    </span>
  );
}
